import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import MaterialTable, { MTableToolbar } from '@material-table/core';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';
import { MuiThemeProvider, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { TABLE_OPTIONS } from '../../../consts/tableOptions';
import Optional from '../../../utils/optional';
import withDetailsView from '../../../utils/withDetailsView';
import styles, { themes } from '../styles';
import { logUserActions } from '../actions/logUserToDistgroup';
import QueuesTableTitle from './QueuesTableTitle';
import tableColumns from './tableColumns';
import withUserCheck from '../../../utils/withUserCheck';
import useLocalTableStore from '../../../utils/useLocalTableStore';
import { actions as reduxActions } from '../reducers';
import filterCustomJobs from '../../../utils/filterCustomJobs';
import { doesArrayHasLength, isDefined } from '../../../utils/isDefined';
import CustomJobsMenu from '../../../partials/customJobsMenu/CustomJobsMenu';
import agentsSubscriptions from '../actions/agentSubscriptions';

export function UserViewQueuesTable({
  classes,
  queues,
  intl,
  logUserActions,
  isAdminUser,
  isLoading,
  connectDomain,
  isCurrentUserSelectedClientUser,
  userMitelId,
  columns,
  setColumns,
  customJobs,
  queuesGroupedByUser
}) {
  const tableDefaultColumns = useMemo(() => {
    return tableColumns({
      intl,
      logUserActions,
      isAdminUser,
      connectDomain,
      isCurrentUserSelectedClientUser,
      userMitelId,
      userView: true
    });
    // eslint-disable-next-line
  }, [userMitelId]);

  const { onChangeColumnHidden } = useLocalTableStore({
    tableName: 'Queues',
    setColumns,
    tableDefaultColumns
  });

  useEffect(() => {
    queuesGroupedByUser.map(el => {
      if (isDefined(el.parentId)) {
        return el;
      }
      agentsSubscriptions({ userId: el.connectId });
      return el;
    });
    // eslint-disable-next-line
  }, []);

  const mappedJobs = useMemo(() => {
    return filterCustomJobs(customJobs, 'Queues');
  }, [customJobs]);

  const actions = useMemo(
    () => {
      let buttons = [];

      if (doesArrayHasLength(mappedJobs)) {
        buttons = [
          ...buttons,
          {
            icon: () => <CustomJobsMenu customJobs={mappedJobs} />,
            onClick: () => {},
            isFreeAction: true
          }
        ];
      }

      return buttons;
    },
    // eslint-disable-next-line
    [customJobs]
  );

  return (
    <MuiThemeProvider theme={themes.table}>
      <div className={classes.tableContainer}>
        {isLoading ? (
          <div className={classes.tableOwerlay}>
            <CircularProgress />
          </div>
        ) : null}
        <MaterialTable
          components={{
            Toolbar: props => (
              <MTableToolbar
                classes={{
                  title: classes.toolbarTitle
                }}
                {...props}
              />
            )
          }}
          title={<QueuesTableTitle />}
          actions={actions}
          columns={columns}
          data={queuesGroupedByUser}
          options={{ ...TABLE_OPTIONS.QUEUES }}
          style={styles.table}
          onChangeColumnHidden={onChangeColumnHidden}
          parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
        />
      </div>
    </MuiThemeProvider>
  );
}

const mapStatesToProps = ({ queues, auth, selectClient, loader }) => {
  return {
    isLoading: loader.isSpinVisible,
    queues: Optional(queues.queues).or([]),
    columns: queues.columns,
    connectDomain: Optional(selectClient.selectedClient)
      .map(client => client.connect30_domain)
      .or(auth.defaultClient.connect30_domain),
    userMitelId: auth.user.connect30_user_id,
    queuesGroupedByUser: queues.queuesGroupedByUser
  };
};

const mapDispatchToProps = {
  logUserActions,
  setColumns: reduxActions.setColumns
};

export default flowRight(
  injectIntl,
  withUserCheck,
  withDetailsView,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(UserViewQueuesTable);
